module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/poster-zh.82dc18aa.jpg";